module.exports = __webpack_public_path__ + "static/proposito-860e1a5b4aa9ecf98030cb7493adfa65.jpg";